// extracted by mini-css-extract-plugin
module.exports = {"gradientText":"gradient-text_gradientText___moFh","gradient48":"gradient-text_gradient48__4af9c"};